import React from "react";
import Seo from "@/components/Seo";
import Hero from "@/sections/Hero";
import TrustStrip from "@/sections/TrustStrip";
import ProblemSection from "@/sections/ProblemSection";
import Differentiation from "@/sections/Differentiation";
import ServicesOverview from "@/sections/ServicesOverview";
import StartupJourney from "@/sections/StartupJourney";
import FounderSection from "@/sections/FounderSection";
import ReviewsSection from "@/sections/ReviewsSection";
import ResourcesPreview from "@/sections/ResourcesPreview";
import FAQSection from "@/sections/FAQSection";
import FinalCTA from "@/sections/FinalCTA";

export default function HomePage() {
 return (
 <div data-testid="page-home">
 <Seo
  title="Company Registration in Mumbai | HG Corporates"
  description="Founder-led Pvt Ltd, LLP, OPC, GST and DPIIT registration for first-time founders in Mumbai, Navi Mumbai and Thane. Rated 4.9/5 on 251 Google reviews."
  path="/"
 />
 <Hero />
 <TrustStrip />
 <ProblemSection />
 <Differentiation />
 <ServicesOverview />
 <StartupJourney />
 <FounderSection />
 <ReviewsSection />
 <ResourcesPreview />
 <FAQSection />
 <FinalCTA />
 </div>
 );
}
